// =============================================================================
// Child theme entry — client-specific JS goes here.
// The parent theme (ai-zippy) handles core behaviors; use this file only for
// client overrides or new features that don't belong in core.
// =============================================================================

// Example:
// import "./modules/client-hero.js";

// Mobile navigation — hamburger toggle for the site header
document.addEventListener("DOMContentLoaded", () => {
	const toggle = document.querySelector(".js-header__toggle");
	const nav = document.querySelector(".js-header__nav");

	if (!toggle || !nav) return;

	toggle.addEventListener("click", () => {
		const open = nav.classList.toggle("is-open");
		toggle.classList.toggle("is-open", open);
		toggle.setAttribute("aria-expanded", open ? "true" : "false");
	});

	// Close the menu after navigating via a link
	nav.addEventListener("click", (e) => {
		if (e.target.closest("a")) {
			nav.classList.remove("is-open");
			toggle.classList.remove("is-open");
			toggle.setAttribute("aria-expanded", "false");
		}
	});
});

// Instagram carousel — infinite loop, arrows shift one slide per click
document.addEventListener("DOMContentLoaded", () => {
	const carousel = document.querySelector(".js-insta__carousel");
	if (!carousel) return;

	const viewport = carousel.querySelector(".js-insta__viewport");
	const track = carousel.querySelector(".js-insta__track");
	const prev = carousel.querySelector(".js-insta__arrow--prev");
	const next = carousel.querySelector(".js-insta__arrow--next");
	if (!track || track.children.length < 2) return;

	let busy = false;

	const gap = () => parseFloat(getComputedStyle(track).gap) || 0;

	// Run after the track transition ends — with a timeout fallback for
	// environments that throttle rendering (background tabs, headless QA)
	const afterTransition = (fn) => {
		let done = false;
		const finish = () => {
			if (done) return;
			done = true;
			fn();
		};
		track.addEventListener("transitionend", finish, { once: true });
		setTimeout(finish, 500);
	};

	// Highlight the middle visible slide (index-based — immune to
	// mid-transition measurements)
	const setCenter = () => {
		const slides = [...track.children];
		const slideW = slides[0].offsetWidth + gap();
		const visible = Math.max(1, Math.round(viewport.clientWidth / slideW));
		const centerIdx = Math.min(Math.floor(visible / 2), slides.length - 1);
		slides.forEach((slide, i) => {
			slide.classList.toggle("is-center", i === centerIdx);
		});
	};

	const shift = (dir) => {
		if (busy) return;
		busy = true;
		const step = track.children[0].getBoundingClientRect().width + gap();

		if (dir === 1) {
			// Next: slide left, then move the first slide to the end
			track.style.transition = "transform 0.4s ease";
			track.style.transform = `translateX(${-step}px)`;
			afterTransition(() => {
				track.style.transition = "none";
				track.appendChild(track.children[0]);
				track.style.transform = "translateX(0)";
				void track.offsetWidth; // force reflow before measuring
				setCenter();
				busy = false;
			});
		} else {
			// Prev: move the last slide to the front, then slide right
			track.style.transition = "none";
			track.insertBefore(track.children[track.children.length - 1], track.children[0]);
			track.style.transform = `translateX(${-step}px)`;
			void track.offsetWidth; // force reflow so the jump is not animated
			track.style.transition = "transform 0.4s ease";
			track.style.transform = "translateX(0)";
			afterTransition(() => {
				setCenter();
				busy = false;
			});
		}
	};

	if (next) next.addEventListener("click", () => shift(1));
	if (prev) prev.addEventListener("click", () => shift(-1));

	setCenter();
	window.addEventListener("resize", setCenter);
});

console.log("[ai-zippy-child] loaded");
